import type { Jet } from '~/jet';
import { Persistence } from '~/jet/dependencies/persistence';
import type { SetPersistenceItemAction } from '@jet-app/music-classical/action-model/SetPersistenceItemAction';
import type { LoggerFactory } from '@amp/web-apps-logger';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger } = dependencies;
    const persistence = new Persistence(logger);

    const log = logger.loggerFor(
        'jet/action-handlers/set-persistence-item-action',
    );

    // See: https://github.pie.apple.com/mediaapps/MusicUI/blob/597ef26de1189bfcbf9d57425b71b08a3cf4702e/MusicUI/ActionImplementation/SetPersistenceItemActionImplementation.swift#L14-L18
    jet.onAction(
        'setPersistenceItemAction',
        async (action: SetPersistenceItemAction) => {
            log.info('received setPersistenceItemAction:', action);
            persistence.setValueForKey(action.key, action.item, action.scope);
            return 'performed';
        },
    );
}
